/**
 * Timesheet i18n scaffold — pass-through stub for now.
 *
 * Usage at call site:
 *   import { t } from './i18n';
 *   <h1>{t('dashboard.title', 'Harmony Timesheet')}</h1>
 *
 * When the team is ready to localise, swap this file's implementation for
 * react-i18next (or vanilla i18next + ICU) and provide locale dictionaries.
 * The shape `t(key, defaultText)` is intentionally compatible with both
 * libraries — no call-site changes needed.
 *
 * Wrapping strings now (even though every call just returns its default
 * today) means the eventual retrofit is a single-file swap rather than a
 * grep-and-edit across every component.
 */

// In a real implementation this would consult an i18next instance + the
// current locale. For now it's deliberately a one-liner.
export const t = (key, defaultText) => defaultText;

// Future: when react-i18next lands, expose a useT() hook here so components
// re-render on language change. Until then `t` is a stable function reference
// (which is also valid as a useT()-equivalent for static rendering).
export const useT = () => t;
